import React, { useEffect, useRef } from "react";
import { Box, FormControlLabel, Switch } from "@mui/material";
import noimg from "../../icons/noimg.png";

export default function ZoomController({ zoomOn, setZoomOn, color }) {
  return (
    <FormControlLabel
      control={
        <Switch
          checked={zoomOn}
          onChange={(e) => setZoomOn(e.target.checked)}
        />
      }
      label="Zoom"
      sx={{
        color: color,
        border: `solid 1px rgba(25, 118, 210, 0.5)`,
        // px: 1,
        mr: 1,
        pr: 1,
        borderRadius: 1,
      }}
    />
  );
}
